import { render, staticRenderFns } from "./PartnerReportCreateForm.vue?vue&type=template&id=b54c46b6&scoped=true"
import script from "./PartnerReportCreateForm.vue?vue&type=script&lang=ts"
export * from "./PartnerReportCreateForm.vue?vue&type=script&lang=ts"
import style0 from "./PartnerReportCreateForm.vue?vue&type=style&index=0&id=b54c46b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54c46b6",
  null
  
)

export default component.exports